import { TextField as TextFieldWrapper, styled } from '@mui/material';

export const CheckoutFieldCss = styled(TextFieldWrapper)({
  '& .MuiFormLabel-root': {
    color: '#949494',
    fontSize: '16px',
    fontWeight: '400',
    letterSpacing: '.4px',
    lineHeight: '19px',
    '&.Mui-focused': {
      color: '#949494',
    },
  },
  '& .MuiOutlinedInput-root': {
    fontSize: '16px',
    lineHeight: '22px',
    '& fieldset': {
      borderColor: 'red',
    },
    '&:hover fieldset': {
      borderColor: '#D7DDE9',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#D7DDE9',
      borderWidth: '1px',
    },
    '&.Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#D7DDE9',
      },
    },
  },
  '& .MuiFormLabel-asterisk': {
    color: '#FC5808',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    height: '36px',
    lineHeight: '19px',
    width: '100%',
    color: '#949494',
    '&:focus': {
      outline: '0px',
    },
    '&:hover': {
      outline: '0px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #D7DDE9',
      borderRadius: '8px',
      '&:hover': {
        outline: 'transparent',
      },
      '& legend > span': {
        padding: 0,
      },
    },
  },
});
